<template>
  <div>
    <!-- 装箱界面 -->
    <el-dialog :title="$t('message.encasementInterface')" :close-on-click-modal="false"
      :visible.sync="$parent.encasementDialogVisible" width="1188px" center>
      <div class="content">
        <!-- oneCasePack: '每一箱装箱数', -->
        <div class="head-title">
          <!-- 当前选中箱数： -->
          <span>
            {{ $t("message.selectBoxNum") }}：
            <span class="color" style="margin-right: 70px">{{
              boxList.length
            }}</span>
          </span>
          <!--选中箱号  -->
          <span>{{ $t("message.selectBoxes") }}：</span>
          <span class="color" v-for="(item, index) in boxList" :key="index">{{ item.box_no }}、</span>
        </div>
        <div class="table">
          <ol>
            <!-- 订单号 -->
            <li class="flex2">{{ $t("message.orderNumber") }}</li>
            <li class="flex05">NO</li>
            <!-- 照片 -->
            <li>{{ $t("message.pic") }}</li>
            <!-- 商品属性 -->
            <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
            <!-- 提出待装箱数量 -->
            <li>{{ $t("message.putForwardTheQuantityToBePacked") }}</li>
            <!-- 每一箱装箱数 -->
            <li>{{ $t("message.oneCasePack") }}</li>
            <!-- 剩余待装箱数 -->
            <li>{{ $t("message.remainingNumberToBePacked") }}</li>
          </ol>
          <ul v-for="(item, index) in list" :key="index">
            <!-- 订单号 -->
            <li class="flex2">{{ item.order_sn }}</li>
            <li class="flex05">{{ index + 1 }}</li>
            <!-- 照片 -->
            <li>
              <el-popover placement="right" width="300" trigger="hover">
                <img :src="item.pic" alt="" style="width: 300px; height: 300px" />
                <a href="JavaScript:;" slot="reference">
                  <el-image :src="item.pic" style="width: 60px; height: 60px; border-radius: 4px">
                    <div slot="placeholder" class="image-slot">
                      加载中<span class="dot">...</span>
                    </div>
                  </el-image>
                </a>
              </el-popover>
            </li>
            <!-- 商品属性 -->
            <li class="flex15">
              <div class="attribute">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 提出待装箱数量 -->
            <li>
              {{ item.maxUpNum }}
            </li>
            <!-- 每一箱装箱数 -->
            <li>

              <el-input v-model="item.num" type="number" onfocus="this.select()" @input="maxItemNum(item, index)"
                onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
            </li>
            <!-- 剩余待装箱数 -->
            <li>
              {{ item.surplus }}
            </li>
          </ul>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="$parent.encasementDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.ok")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    boxList: { type: Array },
    list: { type: Array },
  },
  data() {
    return {
      num: "",
    };
  },
  created() {
    console.log(this.list);
  },
  methods: {
    // 保存
    save() {
      let datas = {
        ids: [],
        list: [],
      };
      this.boxList.forEach((item) => {
        datas.ids.push(item.id);
      });
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].num == 0 || !this.list[i].num)
          return this.$message.error("请输入每一箱装箱数");
        datas.list.push({
          num: this.list[i].num,
          order_purchase_id: this.list[i].order_purchase_id,
        });
      }
      this.$api.inspectionApi.intoBox(datas).then((res) => {
        // 有抽查的是否跳过抽查
        if (res.code == 10006) {
          this.skipSpotCheck(res.msg, datas)
          return false
        }
        this.$message.success(res.msg);
        this.$parent.encasementSuccess();
      });
    },
    // 跳过抽查
    skipSpotCheck(msg, datas) {
      this.$confirm(
        msg,
        this.$t("message.hint"),
        {
          confirmButtonText: '继续操作', //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          datas.reconfirm = 1
          this.$api.inspectionApi.intoBox(datas).then((res) => {
            this.$message.success(res.msg);
            this.$parent.encasementSuccess();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 最大数
    maxItemNum(data, i) {
      let nums = data.num * this.boxList.length; //箱子数*每箱的数量
      if (data.maxUpNum - nums < 0) {
        this.$message.error("装箱数大于提出待装箱数量");
        this.list[i].num = 0;
        this.list[i].surplus = data.maxUpNum;
      } else {
        this.list[i].surplus = data.maxUpNum - nums;
      }
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;

  .head-title {
    height: 56px;
    background: #545467;
    border-radius: 4px;
    color: #fff;
    font-size: 16px;
    padding: 0 24px;
    line-height: 56px;

    .color {
      color: #f9f871;
    }
  }

  .table {
    margin-top: 20px;

    .flex05 {
      flex: 0.5;
    }

    .flex15 {
      flex: 1.5;
    }

    .flex2 {
      flex: 2;
    }

    .attribute {
      width: 100%;
      text-align: left;
      max-height: 80px;
      background-color: #fff;
      padding: 10px;
    }
  }
}
</style>